function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.778 4h12.444C19.2 4 20 4.8 20 5.778v12.444C20 19.2 19.2 20 18.222 20H5.778C4.8 20 4 19.2 4 18.222V5.778C4 4.8 4.8 4 5.778 4zm5.545 11.485l5.5-6.5-1.146-.97-4.973 5.878L8.28 11.47l-1.06 1.06 3 3 .576.577.527-.622z"
});

function SvgSelectedCheckboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _ref);
}

export default SvgSelectedCheckboxIcon;